// Node imports
import { BaseGameState} from "@quest/murka-games-behavior-leopard/dist/";
import { dispatcher, ingenuity } from "@quest/base-core";
import { DisplayObject } from "pixi.js-legacy";
import { reelPanel, SlotEventConstants } from "@quest/slot-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { SelectionScreenView } from "../SelectionScreen/SelectionScreenView";
import { SelectionScreenController } from "../SelectionScreen/SelectionScreenController";
import { StackSymbolFeatureViewBG } from "../StackFeatureBG/StackSymbolFeatureViewBG";
import { StackSymbolFeatureControllerBG } from "../StackFeatureBG/StackSymbolFeatureControllerBg";
import { FlowerOnionTrailView } from "../FlowerCollectFeature/FlowerOnionTrail/FlowerOnionTrailView";
import { FlowerOnionTrailController } from "../FlowerCollectFeature/FlowerOnionTrail/FlowerOnionTrailController";
import { TopLogoViewGame } from "../TopLogo/TopLogoViewGame";
import { WildDragonReelControllerBG } from "../FlowerCollectFeature/WildReelDragonBG/WildDragonReelControllerBG";
import { WildDragonReelViewBG } from "../FlowerCollectFeature/WildReelDragonBG/WildDragonReelViewBG";
import { FlowerCollectPanelView } from "../FlowerCollectFeature/FLowerCollectPanel/FlowerCollectPanelView";
import { FlowerCollectPanelController } from "../FlowerCollectFeature/FLowerCollectPanel/FlowerCollectPanelController";
import { TopLogoControllerGame } from "../TopLogo/TopLogoControllerGame";

export class BaseGameStateAT extends BaseGameState {

  private wildReellFeatureViewBG: WildDragonReelViewBG;
  protected wildReellFeatureControllerBG: WildDragonReelControllerBG;
  
  private flowerCollectPanelView: FlowerCollectPanelView;
  protected flowerCollectPanelController: FlowerCollectPanelController;
  // Selection screen
  private selectionScreenView: SelectionScreenView;
  private selectionScreenController: SelectionScreenController;
  // Stack feature
  private stackSymbolView: StackSymbolFeatureViewBG;
  protected stackSymbolController: StackSymbolFeatureControllerBG;
  //flower trail
  private flowerTrailView: FlowerOnionTrailView
  /**
   * to add game specific events
   */
  protected subscribeEventsGame(): void {
    super.subscribeEventsGame();
    dispatcher.on(eventDispatchers.INITIALIZE_SELECTION_SCREEN, this.initializeSelectionScreen, this);
    dispatcher.on(eventDispatchers.DESTROY_SELECTION_SCREEN, this.destroySelectionScreen, this);
    dispatcher.on(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE, this.initializeStackSymbolFeature, this);
    dispatcher.on(eventDispatchers.INITIALIZE_FLOWER_ONION_TRAIL, this.initializeFlowerTrail, this);
    dispatcher.on(eventDispatchers.INITIALIZE_WILD_DRAGON, this.initializeWildReelDragon, this);

  }
  /**
   * to remove game specific events
   */
  protected unSubscribeEvents(): void {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_SELECTION_SCREEN, this.initializeSelectionScreen, this);
    dispatcher.off(eventDispatchers.DESTROY_SELECTION_SCREEN, this.destroySelectionScreen, this);
    dispatcher.off(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE, this.initializeStackSymbolFeature, this);
    dispatcher.off(eventDispatchers.INITIALIZE_FLOWER_ONION_TRAIL, this.initializeFlowerTrail, this);
    dispatcher.off(eventDispatchers.INITIALIZE_WILD_DRAGON, this.initializeWildReelDragon, this);

  }
  // Intialize stack symbol
  protected initializeStackSymbolFeature(): void {
    if (!this.stackSymbolView) {
      this.stackSymbolView = new StackSymbolFeatureViewBG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).stackSymBG);
      this.stackSymbolController = new StackSymbolFeatureControllerBG(this.stackSymbolView);
      this.setLayering(this.stackSymbolView);
    }
  }

  //set layering below winboxes
  private setLayering(obj: any) {
    const winBoxIndex: number = this.getWinBoxIndex();
    winBoxIndex && this.winReelpanel.addChildAt(obj, winBoxIndex);
  }

  //to get winBox Container Index
  private getWinBoxIndex(): number {
    const winBoxContainer: DisplayObject = this.winReelpanel.getChildByName("winboxContainer");
    if (winBoxContainer) { return this.winReelpanel.getChildIndex(winBoxContainer); }
  }

  // Initialize selection screen view & controller
  private initializeSelectionScreen(): void {
    if (!this.selectionScreenView) {
      this.selectionScreenView = new SelectionScreenView(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).selectionScreen);
      this.selectionScreenController = new SelectionScreenController(this.selectionScreenView);
      ingenuity.currentGame.stage.addChild(this.selectionScreenView);
    }
  }
  //to destroy selection screen
  private destroySelectionScreen(): void {
    if (this.selectionScreenView) {
      this.selectionScreenController.reset();
      this.selectionScreenController = null;
      this.selectionScreenView = null;
    }
  }
  /**
   * to initialize Wild reel feature
   */
  protected initializeWinReelPresentation(): void {
    this.winReelpanel = new reelPanel.WinReelPanel(ingenuity.currentGame, this.reelPanel);
    this.view.setWinReelView(this.winReelpanel, 3, "gameReelPanelContainer");
    dispatcher.on(SlotEventConstants.SUBSCRIBE_WINPRESENTATION_PANEL_BG, this.subscribeEvents, this);
    dispatcher.on(SlotEventConstants.UNSUBSCRIBE_WINPRESENTATION_PANEL_BG, this.unsubscribeEvents, this);
    dispatcher.fireEvent(SlotEventConstants.SUBSCRIBE_WINPRESENTATION_PANEL_BG);
    dispatcher.fireEvent(eventDispatchers.CREATE_WIN_MASK);
    this.initializeFlowerCollectPanel();
    this.addBetMsgOnTop()
  }
  /**
   * to add hint box in correct layering
   */
  private addBetMsgOnTop():void{
    this.view.getContainerByID("gameReelPanelContainer").addChild(this.view.getContainerByID("hintBoxContainer"));
  }
  /**to initialize flower collection panel */
  private initializeFlowerCollectPanel(): void {
    if (!this.flowerCollectPanelView) {
      this.flowerCollectPanelView = new FlowerCollectPanelView(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).flowerCollectPanel);
      this.flowerCollectPanelController = new FlowerCollectPanelController(this.flowerCollectPanelView);
      this.winReelpanel.addChildAt(this.flowerCollectPanelView, 0);
    }
  }
  
  // Intialize flower trails
  private initializeFlowerTrail(): void {
    if (!this.flowerTrailView) {
      this.flowerTrailView = new FlowerOnionTrailView(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).flowerCollectTrail);
      new FlowerOnionTrailController(this.flowerTrailView);
      this.view.getContainerByID("gameReelPanelContainer").addChild(this.flowerTrailView);
    }
  }
  // Overrided to initialize top logo
  protected initializeGameLogoView() {
    if(!ingenuity.deviceEnv.isDesktop){
      if (!this.topLogoView) {
        this.topLogoView = new TopLogoViewGame(ingenuity.assetsData.getJSONById(SlotConstantsBehavior.MAIN_DATA).topLogo, this.view);
        new TopLogoControllerGame(this.topLogoView);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
      }
    }}
  /**
 * to initialize wild dragon
 */
  private initializeWildReelDragon(): void {
    if (!this.wildReellFeatureViewBG) {
      this.wildReellFeatureViewBG = new WildDragonReelViewBG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).wildDragonOnReel);
      this.wildReellFeatureControllerBG = new WildDragonReelControllerBG(this.wildReellFeatureViewBG);
      const winBoxIndex: number = this.getWinBoxIndex();
      winBoxIndex ? this.winReelpanel.addChildAt(this.wildReellFeatureViewBG, winBoxIndex) : this.winReelpanel.addChild(this.wildReellFeatureViewBG);
      // this.winReelpanel.addChildAt(this.wildReellFeatureViewBG,0);
    }
  }
}
